import React from 'react';
import { LuBuilding2, LuFolderKanban } from 'react-icons/lu';
import { useScope } from '../contexts/ScopeContext';

const ScopeSwitcher = ({ summary = false }) => {
  const scope = useScope();
  if (scope.status !== 'ready') return null;

  if (summary) {
    return (
      <div className="flex min-w-0 items-center gap-1.5 text-xs text-zinc-400" title={`${scope.organization.name} / ${scope.project.name}`}>
        <LuFolderKanban className="h-4 w-4 shrink-0 text-amber-400" />
        <span className="max-w-24 truncate">{scope.project.name}</span>
      </div>
    );
  }

  return (
    <div className="flex min-w-0 flex-col gap-1 sm:flex-row" aria-label="Active organization and project">
      <label className="relative flex min-w-0 items-center gap-1.5">
        <LuBuilding2 className="h-4 w-4 shrink-0 text-zinc-500" aria-hidden="true" />
        <span className="sr-only">Organization</span>
        <select
          value={scope.organization.id}
          onChange={(event) => scope.selectOrganization(event.target.value)}
          className="max-w-40 truncate rounded-md border border-zinc-700 bg-zinc-900 px-2 py-1.5 text-xs text-zinc-200 focus:border-amber-500 focus:outline-none"
        >
          {scope.organizations.map((organization) => <option key={organization.id} value={organization.id}>{organization.name}</option>)}
        </select>
      </label>
      <label className="relative flex min-w-0 items-center gap-1.5">
        <LuFolderKanban className="h-4 w-4 shrink-0 text-amber-400" aria-hidden="true" />
        <span className="sr-only">Project</span>
        <select
          value={scope.project.id}
          onChange={(event) => scope.selectProject(event.target.value)}
          className="max-w-44 truncate rounded-md border border-zinc-700 bg-zinc-900 px-2 py-1.5 text-xs text-zinc-200 focus:border-amber-500 focus:outline-none"
        >
          {scope.projects.map((project) => <option key={project.id} value={project.id}>{project.name}</option>)}
        </select>
      </label>
    </div>
  );
};

export default ScopeSwitcher;
